import {alias, createModelSchema} from "serializr";
import {BaseObject} from "@/common/BaseObject";
import {Schema} from "@/common/Schema";
import {Tile} from "@/modules/redactor/models/utils/Tile";
import {MapAddonType} from "@/modules/redactor/models/map-addon/core/MapAddonType";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";

export class MapAddonModel extends BaseObject {

    constructor(type) {
        super();

        this._key = null;
        this._name = null;
        this._type = type;
        this._group = null;
        this._anchorTile = null;
        this._scrollTile = null;
        this._remoteAssets = false;
    }

    get type() {
        return this._type;
    }

    get key() {
        return this._key;
    }

    set key(value) {
        this._key = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    get group() {
        return this._group;
    }

    set group(value) {
        this._group = value;
    }

    get anchorTile() {
        return this._anchorTile;
    }

    set anchorTile(value) {
        this._anchorTile = value;
    }

    get scrollTile() {
        return this._scrollTile;
    }

    set scrollTile(value) {
        this._scrollTile = value;
    }

    get remoteAssets() {
        return this._remoteAssets;
    }

    set remoteAssets(value) {
        this._remoteAssets = value;
    }

    valid() {

        if (!MapAddonType.is(this.type) || MapAddonType.isNone(this.type)) {
            return false;
        }

        if (!this.key || this.key.length <= 0) {
            return false;
        }

        if (!this.name || this.name.length <= 0) {
            return false;
        }

        if (this.anchorTile && !this.anchorTile.valid()) {
            return false;
        }

        if (this.scrollTile && !this.scrollTile.valid()) {
            return false;
        }

        if (!this.group || !RedactorUtils.getMapAddonGroup(this.group)) {
            return false;
        }

        return true;
    }

    copy() {
        let value = super.copy();
        value._id = "";
        value._enabled = false;
        return value;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new MapAddonModel());
        } else if (target instanceof MapAddonModel) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(MapAddonModel, {
    _key: alias("key", Schema.primitive()),
    _name: alias("name", Schema.primitive()),
    _type: alias("type", MapAddonType.schema()),
    _group: alias("group", Schema.primitive()),
    _anchorTile: alias("anchor_tile", Tile.schema()),
    _scrollTile: alias("scroll_tile", Tile.schema()),
    _remoteAssets: alias("remote_assets", Schema.primitive()),
});
